import { ReactNode } from 'react';
import { getFormattedDate } from 'lib/common';
import { Box } from 'components/common/box';

interface Props {
  children: ReactNode;
  date: string;
}

const UpdatesItem = ({ children, date }: Props) => (
  <div className="item">
    <Box title={getFormattedDate({ date })}>
      <div className="content">{children}</div>
    </Box>

    <style jsx>{`
      .item:not(:first-child) {
        margin-top: 50px;
      }
    `}</style>
  </div>
);

export default UpdatesItem;
